<template>
    <b-card no-body>
        <b-modal id="description" :title="approveOrRejectData.title" no-close-on-esc no-close-on-backdrop >
            <div class="row">
                <div class="col-12">
                    <label class="form-label">Açıklama</label>
                    <textarea class="form-control" v-model="approveOrRejectData.description" rows="3" placeholder="Açıklama"></textarea>
                </div>
            </div>
            <template #modal-footer><v-executer :loading="approveOrRejecting" :disabled="!approveOrRejectData.description" :action="approveOrReject">Gönder</v-executer></template>
        </b-modal>

        <v-table ref="table" name="my-incident-approvals" :fields="fields" :items="items" :buttons="buttons" with-items> </v-table>

        <b-modal id="view-incident-detail-modal" size="lg" :title="`Vukuat Detayları - ${selectedIncidentDetail ? selectedIncidentDetail.RefNumber : ''}`" hide-footer>
            <b-overlay :show="detailLoading">
                <incident-detail :details="selectedIncidentDetail" :change-requests="changeRequests"/>
            </b-overlay>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BModal, BOverlay } from "bootstrap-vue";
import IncidentOperationsApi from "@/api/incident-operations";
import IncidentDetail from "./components/IncidentDetail.vue";

export default {
    components: {
        BCard,
        BModal,
        BOverlay,
        IncidentDetail,
    },
    data() {
        return {
            items: [],
            selectedIncidentDetail: null,
            changeRequests:[],
            detailLoading: false,
            fields: [
                { name: "Referans No", key: "RefNumber", thClass: "w-20", sortable: false },
                { name: "Personel", key: "EmployeeFullName", thClass: "w-40", sortable: false },
                { name: "Hareket Tarihi", key: "ActionDateStr", thClass: "w-20", sortable: false },
                {
                    name: "Durum",
                    key: "ApprovalStatus",
                    thClass: "w-20",
                    sortable: false,
                    tdClass: "text-center",
                    component: true,
                    componentOptions: { name: "incident/IncidentApprovalStatusBadge" },
                },
            ],
            approveOrRejectData:{
                title:'',
                description:'',
                approve: null,
                ApprovalStatusId:null
            },
            approveOrRejecting:false,
            buttons: [
                { text: "İncele", key: "view", icon: "EyeIcon", variant: "primary", action: this.viewDetails },
                { text: "Onayla", key: "approve", icon: "CheckIcon", variant: "success", action: this.approve },
                { text: "Reddet", key: "reject", icon: "XIcon", variant: "danger", action: this.reject }
            ],
        };
    },
    mounted() {
        this.fetchMyApprovals();
    },
    methods: {
        fetchMyApprovals() {
            this.$refs.table.setLoading(true);
            IncidentOperationsApi.myApprovals()
                .then((res) => {
                    this.items = res.data.Data || [];
                })
                .finally(() => {
                    this.$refs.table.setLoading(false);
                });
        },
        approve(item){
            this.approveOrRejectData.ApprovalStatusId = item.ApprovalStatusId
            this.approveOrRejectData.title = 'Onayla'
            this.approveOrRejectData.approve = true
            this.approveOrRejectData.description = ''
            this.$showModal('description')
        },
        reject(item){
            this.approveOrRejectData.ApprovalStatusId = item.ApprovalStatusId
            this.approveOrRejectData.title = 'Reddet'
            this.approveOrRejectData.approve = false
            this.approveOrRejectData.description = ''
            this.$showModal('description')
        },
        approveOrReject(){
            this.approveOrRejecting = true
            IncidentOperationsApi.ChangeApprovalStatus(
                this.approveOrRejectData.ApprovalStatusId,
                this.approveOrRejectData.approve,
                this.approveOrRejectData.description
            ).then(res => {
                if(res.data.Success){
                    this.fetchMyApprovals()
                    this.$hideModal('description')
                }
                this.approveOrRejecting = false
                this.$result(res)
            }).catch(err => {
                this.approveOrRejecting = false
                this.$result(null,err)
            })
        },
        viewDetails(item) {
            this.selectedIncidentDetail = null;
            this.changeRequests = []
            this.changeRequests = item.ChangeRequests || []
            this.detailLoading = true;
            this.$bvModal.show("view-incident-detail-modal");

            IncidentOperationsApi.Get(item.IncidentId)
                .then((res) => {
                    if (res.data.Success) {
                        this.selectedIncidentDetail = res.data.Data;
                    } else {
                        this.$result(res);
                        this.$bvModal.hide("view-incident-detail-modal");
                    }
                })
                .finally(() => {
                    this.detailLoading = false;
                });
        },
    },
};
</script>
